import React from "react";
import OutlinedDiv from "../common/OutlinedDiv";
import {MigrationStrategy, MigrationStrategyLabels} from "../../models/OrganizationConfiguration/MigrationStrategy";

import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";

interface MigrationStrategySelectProps {
  value: MigrationStrategy | "";
  onChange: (value: MigrationStrategy | "") => void;
  label: string;
  required: boolean;
  disabled?: boolean;
}

const MigrationStrategySelect: React.FC<MigrationStrategySelectProps> = ({
  value,
  onChange,
  label,
  required = false,
  disabled
}) => {
  const handleChange = (selectedValue: string) => {
    if (selectedValue) {
      onChange(selectedValue as MigrationStrategy);
    }
  };

  return (
    <OutlinedDiv label={label}>
      <ToggleGroup
        type="single"
        className="w-full h-full"
        value={value}
        onValueChange={handleChange}
        disabled={disabled}
      >
        {Object.values(MigrationStrategy).map((strategy) => (
          <ToggleGroupItem className="flex-1" key={strategy} value={strategy}>
            {MigrationStrategyLabels[strategy]}
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
    </OutlinedDiv>
  );
};

export default MigrationStrategySelect;
